<template>
  <div class="item_container" @click="itemClick($event,item.id)">
    <div :style="{height:imageHeight+'px'}">
      <van-image :radius="3" :width="imageWidth" :height="imageHeight" class="item_left_img" :src="src?src:item.imgUrl" lazy-load />
    </div>
    <slot name="right_container">
      <div class="item_right" v-if="!tagIsArray">
        <div class="right_title">{{item.title}}</div>
        <slot name="right_label" :item="item">
          <div class="right_label" v-if="item.tags">
            <div class="label_item" v-for="(item,index) in item.tags.split(',')" :key="index">{{item}}</div>
            <!-- <div class="label_item">亲子溜娃</div> -->
          </div>
        </slot>
        <slot name="right_time" :item="item">
          <div v-if="isShowPark" class="right_time">{{item.scenicName}}</div>
        </slot>
        <slot name="right_like" :item="item">
          <div class="right_like" v-if="item.likeCount || item.commentCount"><span v-if="item.likeCount">{{item.likeCount}}人收藏</span>&nbsp;&nbsp;&nbsp;<span v-if="item.commentCount">{{item.commentCount}}条评论</span></div>
          <!-- <div class="right_like" v-else>暂无评论</div> -->
        </slot>

      </div>
    </slot>
    <slot name="item_right"></slot>
  </div>
</template>

<script>
import Vue from "vue";
import { Lazyload } from "vant";
Vue.use(Lazyload)
export default {
  name: "left-img",
  data() {
    return {

    };
  },
  props: {
    // tag数据类型是否是数组
    tagIsArray: {
      default: () => { return false },
      type: Boolean
    },
    // 数据源
    item: {
      default: () => {
        return {
          imgUrl: 'https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1089874897,1268118658&fm=26&gp=0.jpg',
          title: '锦城湖环湖轻松有【与家人一起放松】',
          tags: '亲子,和谐,奋斗,沮丧',
          scenicName: '锦城湖公园',
          likeCount: 11,
          commentCount: 11,
          id: 'sss'
        }
      },
      type: Object
    },
    // 图片宽度
    imageWidth: {
      default: () => { return 75 },
      type: Number
    },
    // 图片高度
    imageHeight: {
      default: () => { return 100 },
      type: Number
    },
    src: {
      default: () => { return '' },
      type: String
    },
    // 是否隐藏所属景区
    isShowPark: {
      default: () => { return true },
      type: Boolean
    }
  },
  methods: {
    // item点击事件
    itemClick(event, id) {
      this.$emit('itemClick', id);
    }
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.item_container {
  display: flex;
  margin-bottom: 25px;
  .item_right {
    width: calc(100% - 75px);
    padding-left: 14px;
    box-sizing: border-box;
    .right_title {
      font-size: 16px;
      color: black;
      font-weight: bold;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .right_time,
    .right_like {
      color: rgba(0, 0, 0, 0.5);
      font-size: 12px;
    }
    .right_like {
      margin-bottom: 0;
    }
    .right_label {
      display: flex;
      align-items: center;
      margin-bottom: 0px;
      div {
        font-size: 11px;
        color: #6e5adb;
        background: rgba(97, 69, 247, 0.15);
        margin-right: 5px;
        padding: 0px 4px;
        border-radius: 3px;
      }
    }
    div {
      margin-bottom: 7px;
    }
    .right_time {
      margin-bottom: 4px;
    }
  }
}
</style>
